import React from 'react';
import HandbookLayout from './components/HandbookLayout';
import cnwData from './cnw.json';

const CNWHandbook: React.FC = () => {
  // Cast data to expected layout format if necessary
  return <HandbookLayout data={cnwData as any} />;
};

export default CNWHandbook;
